/* RIPSPEC theme behaviour: header menus, drawer, part finder, contact topics, cart count. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Header height for Horizon's sticky product gallery */
  function setHeaderHeight() {
    var h = $('.rs-header');
    if (h) document.body.style.setProperty('--header-height', h.offsetHeight + 'px');
  }

  /* Mega menus */
  function initHeader() {
    var header = $('.rs-header');
    if (!header) return;
    var toggles = $$('[data-rs-mega-toggle]', header);
    var closeTimer;
    function closeAll(except) {
      toggles.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });
    }
    function open(t) {
      closeAll(t);
      t.setAttribute('aria-expanded', 'true');
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = false;
    }
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    toggles.forEach(function (t) {
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (t.getAttribute('aria-expanded') === 'true') closeAll(); else open(t);
      });
      if (hoverable && panel) {
        [t, panel].forEach(function (el) {
          el.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(t); });
          el.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 180); });
        });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(); });

    var burger = $('[data-rs-burger]', header);
    var drawer = $('[data-rs-drawer]', header);
    function closeDrawer() { if (drawer) { drawer.hidden = true; burger && burger.setAttribute('aria-expanded', 'false'); } }
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var isOpen = !drawer.hidden;
        drawer.hidden = isOpen;
        burger.setAttribute('aria-expanded', String(!isOpen));
        closeAll();
      });
    }
  }

  /* Cart count, kept in step with Horizon's cart events */
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-rs-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }

  /* Part finder */
  function initFinder() {
    $$('[data-rs-finder]').forEach(function (root) {
      var tabs = $$('[role="tab"]', root);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', String(on));
            var pane = document.getElementById(t.getAttribute('aria-controls'));
            if (pane) pane.hidden = !on;
          });
        });
      });
      if (window.location.hash && /contact_form|rs-finder-reg/.test(window.location.hash) || $('[data-rs-posted]', root)) {
        var regTab = $('[data-tab="reg"]', root);
        if (regTab) regTab.click();
      }

      var dataEl = $('[data-rs-finder-data]', root);
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var mk = $('[data-rs-make]', root), md = $('[data-rs-model]', root), en = $('[data-rs-engine]', root), go = $('[data-rs-go]', root);
      function fill(sel, items, placeholder) {
        sel.innerHTML = '';
        var o = document.createElement('option');
        o.value = ''; o.textContent = placeholder; sel.appendChild(o);
        items.forEach(function (it, i) {
          var op = document.createElement('option');
          op.value = String(i); op.textContent = it.name; sel.appendChild(op);
        });
        sel.disabled = items.length === 0;
      }
      data.makes.forEach(function (m, i) {
        var op = document.createElement('option'); op.value = String(i); op.textContent = m.name; mk.appendChild(op);
      });
      function current() { return mk.value === '' ? null : data.makes[+mk.value]; }
      mk.addEventListener('change', function () {
        var m = current();
        fill(md, m ? m.models : [], m ? 'Select model' : 'Choose make first');
        fill(en, m ? m.engines : [], m ? 'Select engine' : 'Choose make first');
      });
      go.addEventListener('click', function (e) {
        e.preventDefault();
        var m = current();
        if (!m) { window.location.href = go.getAttribute('data-fallback') || '/collections/all'; return; }
        var model = md.value === '' ? null : m.models[+md.value];
        var engine = en.value === '' ? null : m.engines[+en.value];
        if (!model && !engine) { window.location.href = '/collections/' + m.collection; return; }
        var q = ['tag:' + m.tag];
        if (model) q.push(model.q);
        if (engine) q.push('tag:' + engine.tag);
        window.location.href = '/search?type=product&q=' + encodeURIComponent(q.join(' AND '));
      });
    });
  }

  /* Contact topic chips */
  function initTopics() {
    $$('[data-rs-topics]').forEach(function (root) {
      var form = root.closest('form') || root.parentElement;
      var chips = $$('button[data-topic]', root);
      var label = $('[data-rs-ref-label]', form), input = $('[data-rs-ref-input]', form);
      var topicInput = $('[data-rs-topic-input]', form), tagInput = $('[data-rs-tag-input]', form);
      function select(chip) {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        if (label) label.textContent = chip.getAttribute('data-label');
        if (input) input.placeholder = chip.getAttribute('data-placeholder');
        if (topicInput) topicInput.value = chip.getAttribute('data-topic');
        if (tagInput) tagInput.value = chip.getAttribute('data-tag');
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
      var want = new URLSearchParams(window.location.search).get('topic');
      var start = want && chips.filter(function (c) { return c.getAttribute('data-tag') === want; })[0];
      select(start || chips[0]);
    });
  }

  function init() {
    setHeaderHeight();
    initHeader();
    initFinder();
    initTopics();
    window.addEventListener('resize', setHeaderHeight);
    document.addEventListener('cart:update', refreshCart);
    document.addEventListener('shopify:cart:lines-update', function () {
      setTimeout(refreshCart, 400);
      var d = document.querySelector('theme-drawer#cart-drawer');
      if (d && typeof d.open === 'function') setTimeout(function () { try { d.open(); } catch (e) {} }, 350);
    });
    $$('.rs-cart').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var d = document.querySelector('theme-drawer#cart-drawer');
        if (d && typeof d.open === 'function') { e.preventDefault(); try { d.open(); } catch (err) { window.location.href = a.href; } }
      });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
